// extracted by mini-css-extract-plugin
module.exports = {"FormContainer":"SignInUpForm_FormContainer__3U-DF","ToggleText":"SignInUpForm_ToggleText__3I_le","ToggleLink":"SignInUpForm_ToggleLink__3UqZL"};